import type { MembershipDto } from "@bafe/api-client";

export function slugForOrganisation(
	memberships: MembershipDto[],
	organisationId: string | null | undefined,
): string | null {
	if (!organisationId) return null;
	return memberships.find((item) => item.organisationId === organisationId)?.organisationSlug ?? null;
}

export function membershipForSlug(
	memberships: MembershipDto[],
	workspaceSlug: string,
): MembershipDto | null {
	return memberships.find((item) => item.organisationSlug === workspaceSlug) ?? null;
}

export function workspaceHref(slug: string, path: string): string {
	const trimmed = path.replace(/^\/+/, "");
	return trimmed ? `/workspace/${encodeURIComponent(slug)}/${trimmed}` : `/workspace/${encodeURIComponent(slug)}`;
}

export function parseWorkspaceLocation(pathname: string): { slug: string; restPath: string } | null {
	const match = pathname.match(/^\/workspace\/([^/]+)(\/.*)?$/);
	if (!match) return null;
	const slug = decodeURIComponent(match[1] ?? "");
	const rest = match[2] ?? "";
	return { slug, restPath: rest.length > 0 ? rest : "/" };
}

/** Strip `/workspace/:slug` so legacy helpers see `/manage/...` style paths. */
export function workspaceRestPath(pathname: string): string {
	const parsed = parseWorkspaceLocation(pathname);
	return parsed?.restPath ?? pathname;
}

/** Canonical webmail entry for a workspace (separate Mail SPA at `/mail/{slug}`). */
export function webmailHref(slug: string): string {
	return `/mail/${encodeURIComponent(slug)}`;
}
